export default __webpack_public_path__ + "static/media/m-pesa-logo-green.39e8ea69.png";